import React, { useEffect, useRef } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import Spinner from '../../../components/layout/Spinner';
import { useAuth } from '../../../contexts/AuthContext';
import { useUI } from '../../../contexts/UIContext';
import { useUser } from '../../../contexts/UserContext';

export const ProtectedRoute = ({ children, requiredRole = null }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const { user, loading } = useUser();
  const { showAlert } = useUI();
  const location = useLocation();
  const lastAlertRef = useRef(null);

  useEffect(() => {
    let alertKey = null;

    if (!isAuthenticated) {
      alertKey = `auth:${location.pathname}`;
      if (lastAlertRef.current !== alertKey) {
        showAlert('Please log in to access this page', 'error');
      }
    } else if (requiredRole && user?.user_role !== requiredRole) {
      alertKey = `role:${requiredRole}:${location.pathname}`;
      if (lastAlertRef.current !== alertKey) {
        showAlert('You do not have permission to access this page', 'error');
      }
    }

    lastAlertRef.current = alertKey;
  }, [isAuthenticated, location.pathname, requiredRole, showAlert, user]);

  if (isLoading || (isAuthenticated && loading)) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-white">
        <Spinner />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (requiredRole && user?.user_role !== requiredRole) {
    return <Navigate to="/" replace />;
  }

  return children;
};



